// extracted by mini-css-extract-plugin
module.exports = {"card":"_7Xfay","cover":"_6zcOR","content":"_55UdY","centeredThumbnail":"UfLQ1","label":"_1c04a","title":"OSj57","date":"P8VUU","pvi-no-styles":"oHQRL"};